import Hero from "../components/pages/home/hero/Hero";
import Services from "../components/pages/home/services/Services";
import Clients from "../components/pages/home/clients/Clients";
import About from "../components/pages/home/about/About";
import Tools from "../components/pages/home/tools/Tools";
import Contact from "../components/pages/home/contact/Contact";
import UniversityEngagement from "../components/pages/home/universityEngagement/UniversityEngagement";
import Testimonials from "../components/pages/home/testimonials/Testimonials";

export default function Home() {
    return (
        <main>
            <Hero />
            <Services />
            <Clients />
            <About />
            <UniversityEngagement />
            <Tools />
            <Testimonials />
            <Contact />


        </main>
    )
}